"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCart = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const CmpProductCartTile_1 = require("../../classes/com/CmpProductCartTile");
const Helper_1 = require("../../classes/Helper");
const StateOrderNew_1 = require("./StateOrderNew");
const CartController_1 = require("../controllers/CartController");
const GUIControllerPM_1 = require("../controllers/GUIControllerPM");
class StateCart extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageCart, "Корзина", true);
        this._list = [];
        this.page.ctrls.cbSelectedAll.onclick = () => {
            const checked = this.page.ctrls.cbSelectedAll.el.checked;
            this._list.forEach(i => i.ctrls.cbSelected.el.checked = checked);
        };
        this.page.ctrls.btnDeleteSelected.onclick = () => {
            this._list.forEach(i => {
                if (i.ctrls.cbSelected.el.checked)
                    i.removeFromCart();
            });
        };
        this.page.ctrls.cmpCartTotal.ctrls.btnSubmit.onclick = () => {
            if (!this.app.auth.user) {
                this.app.auth.authAsync((result) => {
                    if (!result) {
                        return;
                    }
                    gs.StateGS.Run(StateOrderNew_1.StateOrderNew);
                    return;
                });
                return super.start();
            }
            else
                gs.StateGS.Run(StateOrderNew_1.StateOrderNew);
        };
        this._handler = () => { this._refreshTotalAsync(); };
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._cartCtrl = this.app.getInst(CartController_1.CartController);
            this.app.getInst(GUIControllerPM_1.GUIControllerPM).setBreadcrumbs([new BreadCrumb_1.BreadCrumb("Главная", "/"), new BreadCrumb_1.BreadCrumb(this.title, `/${StateCart.StateName}`)]);
            this._loadAsync();
            return _super.start.call(this);
        });
    }
    afterStart(args) {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this, args);
            this._cartCtrl.onCartChanged.addHandler(this._handler);
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._cartCtrl.onCartChanged.removeHandler(this._handler);
            _super.stop.call(this);
        });
    }
    _loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._cartCtrl.reload();
            this.page.ctrls.listProducts.html = '';
            const takeIds = [];
            const cart = this._cartCtrl.getCart();
            for (const pos of cart)
                takeIds.push(pos.productId);
            let products = yield this.app.cache.getProductsAsync(takeIds);
            if (!products)
                return;
            this._list = [];
            for (const prod of products) {
                const qty = this._cartCtrl.getQty(prod.id);
                let qtyAtItem = qty;
                if (qty > prod.remainder)
                    qtyAtItem = prod.remainder;
                if (qtyAtItem > 0) {
                    const item = new CmpProductCartTile_1.CmpProductCartTile();
                    item.fill(prod, qtyAtItem, true);
                    this.page.ctrls.listProducts.append(item);
                    this._list.push(item);
                }
                if (qty > prod.remainder) {
                    const itemFailed = new CmpProductCartTile_1.CmpProductCartTile();
                    itemFailed.fill(prod, qty - prod.remainder, false);
                    this.page.ctrls.listProducts.append(itemFailed);
                    this._list.push(itemFailed);
                }
            }
            yield this._refreshTotalAsync();
        });
    }
    _refreshTotalAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let costTotal = 0;
            const cart = this._cartCtrl.getCart();
            for (const pos of cart) {
                const prod = yield this.app.cache.getProductAsync(pos.productId);
                if (!prod)
                    continue;
                const qty = this._cartCtrl.getQty(prod.id);
                costTotal += qty * prod.price;
            }
            const cmpTotal = this.page.ctrls.cmpCartTotal;
            cmpTotal.ctrls.lCostTotal.text = Helper_1.Helper.toPriceString(costTotal);
            cmpTotal.ctrls.lCostDetailsTotal.text = Helper_1.Helper.toPriceString(costTotal);
            cmpTotal.ctrls.lCount.text = cart.length + "";
            cmpTotal.ctrls.blockDiscount.hide();
        });
    }
}
exports.StateCart = StateCart;
StateCart.StateName = "cart";
//# sourceMappingURL=StateCart.js.map